import React from "react";
import "./ListGroupItems.scss";

const ListGroupItems = ({ orgData, getOptionItem }) => {
  return (
    <ul className="menu__list__item-root">
      {orgData.map((item) => (
        <React.Fragment
          key={`${item?.profileName}${item?.productId}${item?.vendorId}`}
        >
          {getOptionItem(item)}
        </React.Fragment>
      ))}
    </ul>
  );
};

export default ListGroupItems;
